import { Button, Spinner, Text, VStack } from "@chakra-ui/react";
import { useFormik } from "formik";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Toast from "../Components/Toast";
import { TsdsInput } from "../Components/TsdsInput";
import { useAppDispatch } from "../Hooks/useAppDispatch";
import { useAppSelector } from "../Hooks/useAppSelector";
import { getToken, login, selectAdminFetching } from "../Redux/AdminSlice";

const LoginScreen = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const token = useAppSelector<any>(getToken);
  const fetching = useAppSelector<boolean>(selectAdminFetching);

  const formik = useFormik({
    initialValues: {
      user_name: "",
      password: "",
    },
    validationSchema: Yup.object({
      user_name: Yup.string().required("Username is Required"),
      password: Yup.string().required("Password is Required"),
    }),
    onSubmit: (values) => {
      dispatch(login(values));
    },
  });

  useEffect(() => {
    if (token) navigate("/home");
  }, [fetching]);

  return (
    <div className="login">
      <Toast />
      <div
        className="img"
        style={{
          position: "fixed",
          opacity: "0.5",
          top: "50%",
          left: "50%",
          marginTop: "-100px",
          marginLeft: "-100px",
        }}
      >
        <img src="logo.png" />
      </div>
      <div
        className="form"
        style={{ maxWidth: "300px", margin: "auto", marginTop: "30px" }}
      >
        <form onSubmit={formik.handleSubmit}>
          <Text fontSize="xl" fontWeight="bold" mb={3}>
            Admin Login
          </Text>
          <VStack>
            <TsdsInput
              label="Username"
              name="user_name"
              type="text"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.user_name}
            />
            <TsdsInput
              label="Password"
              name="password"
              type="password"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.password}
            />

            <Button type="submit">
              Login {fetching ? <Spinner size="sm" ml={2} /> : <></>}
            </Button>
          </VStack>
        </form>
      </div>
    </div>
  );
};

export default LoginScreen;
